import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Provider, useSelector } from 'react-redux';
import { PersonalizationProvider } from '@contensis/personalization-react';
import { store } from './redux';
import SignInCallback from './SignInCallback';
import ContensisUserManager from './helpers/user/ContensisUserManager';
import { defaultTheme } from './theme';
import GlobalStyle from './theme/Global';
import { selectAuthState } from './redux/selectors/user';
import DraggableToolbar from './components/draggableToolbar/DraggableToolbar';

const RenderFacet = () => {
  const token = ContensisUserManager.HasSecurityTokenQueryString();
  const { authenticated } = useSelector(selectAuthState);

  if (authenticated) return <DraggableToolbar />;
  if (token) return <SignInCallback />;
  else return <DraggableToolbar />;
};

const PreviewToolbarWidget = () => {
  return (
    <PersonalizationProvider
      context={window.CONTENSIS_PERSONALIZATION?.context}
      alias={window.ContensisAlias}
      projectId={window.ContensisProjectApiId}
    >
      <Provider store={store}>
        <ThemeProvider theme={defaultTheme}>
          <GlobalStyle />
          <RenderFacet />
        </ThemeProvider>
      </Provider>
    </PersonalizationProvider>
  );
};

export default PreviewToolbarWidget;
